module.exports = __webpack_public_path__ + "static/media/background_2x.463dd5bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/san-francisco/background_2x.jpg
// module id = 956
// module chunks = 27